<div class="section mx-3 my-3">
    <h2 class="text-success">Approved Lenders</h2>
    <div class="card-container">
        <div class="lender-card row align-items-center p-3" *ngFor="let lender of approvedLenders"
            [class.disabled]="!lender.isEnabled">

            <!-- Logo & Name -->
            <div class="col-12 col-md-2 d-flex flex-column align-items-center mb-2 mb-md-0">
                <h3 class="mb-0">{{ lender.lender }}</h3>
                <img [src]="lender.logo" [alt]="lender.lender + ' logo'" class="logo me-2">
            </div>

            <!-- Lender Details Row -->
            <div class="col-12 col-md-8 row">
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Loan Amount:</strong> {{
                    getLoanAmountRange(lender.plans) | currency: 'INR':'symbol':'1.0-0' }}</div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Tenure:</strong> {{
                    getTenureRange(lender.plans) }}</div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Interest:</strong> {{
                    getInterestRange(lender.plans) }} p.m</div>

                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>EMI starts from:</strong> ₹{{
                    getMinEmi(lender.plans) | number }}</div>

                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>APR:</strong> {{ getAprRange(lender.plans) }}
                    p.a
                </div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Penal Charges:</strong> {{
                    lender.penalCharges
                    }}</div>
            </div>

            <!-- Action Buttons -->
            <div class="col-12 col-md-2 text-md-end mt-2 mt-md-0" [class.hide]="!lender.isEnabled">
                <button *ngIf="lender.continue" class="btn-continue w-100" (click)="continueApplication(lender)">
                    Continue
                </button>
                <button *ngIf="!lender.continue" class="btn-select w-100" (click)="SelectLender(lender)">Select</button>
            </div>
        </div>
    </div>
</div>

<!-- Rejected Lenders -->
@if(rejectedLenders.length > 0) {
<div class="section mx-3">
    <h2 class="text-danger">Rejected Lenders</h2>
    <div class="card-container">
        <div class="lender-card disabled row align-items-center p-3" *ngFor="let lender of rejectedLenders">
            <div class="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0">
                <img [src]="lender.logo" [alt]="lender.lender + ' logo'" class="logo me-2">
                <h3 class="mb-0">{{ lender.lender }}</h3>
            </div>
            <div class="col-12 col-md-10">
                <span class="text-muted">Application Not Approved</span>
            </div>
        </div>
    </div>
</div>
}

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>